module.exports = __webpack_public_path__ + "img/psychologique.32fa0004.svg";